











































import { RootScoreCriteriaDetailTypeEnum, ScoreCriteriaDetailTypeEnum } from '../../enums';

import { SteppedAnimationMixin } from '../../mixins';

import { RegularFilter, RegularFilterSelectedValues } from '../../models';

import EpbButton from '../button.component.vue';
import RegularFilterSelector from '../filters/regular-filter-selector.component.vue';
import Searchbox from '../searchbox.component.vue';
import ScoreCriteriaDetailStepper from './explain-score-criteria-detail-stepper.component.vue';

export default {
  name: 'explain-header',
  props: {
    filters: {
      type: Array,
      default: []
    },
    query: String,
    loading: Boolean,
    messages: {
      type: Object,
      required: true
    }
  },
  mixins: [SteppedAnimationMixin],
  components: {
    RegularFilterSelector,
    Searchbox,
    ScoreCriteriaDetailStepper,
    EpbButton
  },
  computed: {
    visibleFilters: function (): RegularFilter[] {
      return this.filters.filter((filter: RegularFilter) => (!filter.config.mandatory || (filter.config.values.length > 1)));
    },
    allFiltersSelected: function (): boolean {
      return this.filters.every((filter: RegularFilter) => (
        !filter.config.mandatory ||
        !!filter.selectedValues.length
      ));
    },
    currentCriteriaDetailType: function (): ScoreCriteriaDetailTypeEnum {
      return (!this.animationFinished ? this.animatedScoreCriteriaDetailTypes[this.currentAnimationStep] : undefined);
    }
  },
  data: function () {
    const animatedScoreCriteriaDetailTypes = [
      ...Object.values(RootScoreCriteriaDetailTypeEnum),
      ScoreCriteriaDetailTypeEnum.CUSTOM_SCORE
    ];
    return {
      animatedScoreCriteriaDetailTypes,
      playAnimationOnStart: false,
      animationStepDurationsInMillis: animatedScoreCriteriaDetailTypes.map(() => 3000),
      animationFinished: false
    };
  },
  methods: {
    onFilterSelectedValuesChange: function (filter: RegularFilter, selectedValues: RegularFilterSelectedValues): void {
      this.$emit('filtersSelectedValuesChange', {
        [filter.config.id]: selectedValues
      });
    },
    onQueryChange: function (newValue: string): void {
      this.$emit('queryChange', (newValue || undefined));
    },
    onAnimationFinished: function (): void {
      this.animationFinished = true;
    },
    onAnimationActionClick: function (): void {
      if (this.animationFinished) {
        this.currentAnimationStep = 0;
      } else {
        this.currentAnimationStep = this.animatedScoreCriteriaDetailTypes.length - 1;
      }
      this.animationFinished = !this.animationFinished;
    }
  },
  mounted: function (): void {
    if (!this.query && !this.playedAnimations.includes(this.animationId)) {
      this.currentAnimationStep = 0;
    } else {
      this.animationFinished = true;
    }
  }
};

